import type { Theme } from '@mui/material/styles'

const MuiInputBase = (baseTheme: Theme) => ({
  styleOverrides: {
    root: {
      fontSize: 'max(16px, 1em)',
      '&.Mui-error': {
        color: baseTheme.palette.error.main,
      },
    },
  },
})

export default MuiInputBase
